module.exports = __webpack_public_path__ + "_assets/img/profile-01.8448c379.svg";